import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { GasDisconnectionPage, GasDisconnectionPageProps } from "./GasDisconnectionPage";

export const EMPTY_PAGE_CONTENT: GasDisconnectionPageProps = {
  pageTitle: "",
};

export const CANONICAL_LINK = "/personal/gas/disconnection";

export const GasDisconnectionPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<GasDisconnectionPageProps>("gas_disconnections", EMPTY_PAGE_CONTENT);
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <GasDisconnectionPage {...routeProps} {...content} />;
};
